const isToday = (timeValue) => {
  const inputDate = new Date(timeValue);
  const today = new Date();

  return (
    inputDate.getDate() === today.getDate() &&
    inputDate.getMonth() === today.getMonth() &&
    inputDate.getFullYear() === today.getFullYear()
  );
};

const normalizePaymentMode = (mode) => Number(mode);

export const PAYMENT_MODE = {
  CASH: 2,
  CARD: 1
};

export const getTicketsAmountTodayByPaymentMode = (ticketsMap, mode) => {
  return Object.values(ticketsMap).reduce((acc, ticket) => {
    if (
      isToday(ticket.ticketDate) &&
      !ticket.incorrect &&
      normalizePaymentMode(ticket.paymentMode) === mode
    ) {
      return acc + (ticket.totalPrice || 0);
    }
    return acc;
  }, 0);
};

export const getTicketsAmountTodayTotal = (ticketsMap) => {
  return Object.values(ticketsMap).reduce((acc, ticket) => {
    const pm = normalizePaymentMode(ticket.paymentMode);
    if (
      isToday(ticket.ticketDate) &&
      !ticket.incorrect &&
      (pm === PAYMENT_MODE.CASH || pm === PAYMENT_MODE.CARD)
    ) {
      return acc + (ticket.totalPrice || 0);
    }
    return acc;
  }, 0);
};

// compatibilidad con el código antiguo
const getTicketsAmountToday = (ticketsMap) =>
  getTicketsAmountTodayTotal(ticketsMap);

export default getTicketsAmountToday;